import React from 'react';
import { cvcInputReact } from '../../utilities/payform';
import unpick from '../../../utilities/unpick';
import HiddenComponents from './hidden-components';

const displayName = 'Card Security Code';

export default function CardSecurityCode(props) {
  const { isValid, hiddenField } = props;
  const p = unpick(props, ['showCardIcon', 'cardType', 'ariaLabel', 'isValid', 'hiddenField']);

  let hiddenComponents = null;

  if (!hiddenField) {
    hiddenComponents = {
      CardExpirationDate: {
        autoComplete: 'cc-exp',
      },
      CreditCardNumber: {
        autoComplete: 'cc-number',
      },
      CardHolderName: {
        autoComplete: 'cc-name',
      },
    };
  }

  return (
    <>
      <input
        type="tel"
        {...p}
        {...cvcInputReact(props)}
        aria-label={props.ariaLabel || displayName}
        aria-placeholder={props.placeholder || ''}
        aria-invalid={!isValid}
      />

      {!hiddenField && <HiddenComponents hiddenComponents={hiddenComponents} />}
    </>
  );
}

CardSecurityCode.displayName = 'CardSecurityCode';
